import _ from 'lodash'
import { request } from '../utils/sockets'
import config from '../config/custom'

export const REQUEST_TERMSANDCONDITIONS = 'termsandconditions/REQUEST_TERMSANDCONDITIONS'
export const GET_TERMSANDCONDITIONS = 'termsandconditions/GET_TERMSANDCONDITIONS'
export const REQUEST_FAILED = 'termsandconditions/REQUEST_FAILED'
export const SET_TERMSANDCONDITIONS = 'termsandconditions/SET_TERMSANDCONDITIONS'
export const ADD_TERMSANDCONDITIONS = 'termsandconditions/ADD_TERMSANDCONDITIONS'
export const UPDATE_TERMSANDCONDITIONS = 'termsandconditions/UPDATE_TERMSANDCONDITIONS'
export const REMOVE_TERMSANDCONDITIONS = 'termsandconditions/REMOVE_TERMSANDCONDITIONS'
export const SET_PAGINATION = 'termsandconditions/SET_PAGINATION'

let initialState = {
    fetching: false,
    items: [],
    selected: null,
    options: {},
    total: 0,
    record: null,
    pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
    }
}

export default (state = initialState, action) => {
    switch (action.type) {
        case REQUEST_TERMSANDCONDITIONS:
            return {
                ...state,
                fetching: true
            }

        case GET_TERMSANDCONDITIONS:
            return {
                ...state,
                items: action.items,
                total: action.pagination && action.pagination.total,
                pagination: action.pagination,
                fetching: false
            }

        case REQUEST_FAILED:
            return {
                ...state,
                fetching: false
            }

        case SET_TERMSANDCONDITIONS:
            return {
                ...state,
                selected: action.id,
                record: action.record
            }

        case SET_PAGINATION:
            return {
                ...state,
                pagination: action.pagination
            }

        case ADD_TERMSANDCONDITIONS:
            return {
                ...state,
                items: [action.item, ...state.items]
            }

        case UPDATE_TERMSANDCONDITIONS:
            let items = [...state.items]
            const index = _.findIndex(items, { id: action.item.id })

            if (index !== -1) {
                items.splice(index, 1, { ...items[index], ...action.item })
            }

            return { ...state, items }

        case REMOVE_TERMSANDCONDITIONS:
            let _items = [...state.items]
            const _index = _.findIndex(_items, { id: action.id })

            if (_index !== -1) {
                _items.splice(_index, 1)
            }

            return { ...state, _items }

        default:
            return state
    }
}


export const getTermsAndConditions = () => (dispatch, getState) => {
        
    const state = getState();
    const { pagination } = state.dispatch;

    dispatch({
        type: REQUEST_TERMSANDCONDITIONS
    })
    request(`${config.baseUrl}/termsandconditions/search`, {
            params: {
                ...state.search,
                page: pagination.page,
                pageSize: pagination.pageSize
            },
    })
        .then(response => {
            dispatch({
                type: GET_TERMSANDCONDITIONS,
                items: response.termsandconditions,
                total: response.pagination.total,
                pagination: response.pagination
            })
        })
        .catch(error => {
            dispatch({
                type: REQUEST_FAILED
            })
        })
}

export const setPagination = (page, pageSize) => (dispatch) => {
    dispatch({
        type: SET_PAGINATION,
        pagination: {
            page,
            pageSize
        }
    })
    return dispatch(getTermsAndConditions())
}

export const getTermAndCondition = (id) => {
    return (dispatch, getState) => {
        request(`${config.baseUrl}/termsandconditions/${id}`)
            .then(response => {
                dispatch({
                    type: SET_TERMSANDCONDITIONS,
                    id: id,
                    record: response.data
                })
            })
            .catch(error => {
                dispatch({
                    type: REQUEST_FAILED
                })
            })
    }
}

export const setTermAndCondition = (id, record) => {
    return dispatch => {
        dispatch({
            type: SET_TERMSANDCONDITIONS,
            id,
            record
        })
    }
}

export const addTermAndCondition = (data) => {
    return (dispatch, getState) => {
        const state = getState()

        if (_.findIndex(state.items, { id: data.id }) === -1) {
            dispatch({
                type: ADD_TERMSANDCONDITIONS,
                item: data
            })
        }
    }
}

export const updateTermAndCondition = (data) => {
    return dispatch => {
        dispatch({
            type: UPDATE_TERMSANDCONDITIONS,
            item: data
        })
    }
}

export const updateTermAndConditionById = (id) => {
    return dispatch => {
        request(`${config.baseUrl}/termsandconditions/${id}`)
            .then(response => {
                dispatch({
                    type: UPDATE_TERMSANDCONDITIONS,
                    item: response
                })
            })
            .catch(() => {
                // 
            })
    }
}

export const removeTermAndCondition = (id) => {
    return dispatch => {
        dispatch({
            type: REMOVE_TERMSANDCONDITIONS,
            id
        })
    }
}



// WEBPACK FOOTER //
// ./src/modules/termsandconditions.js